module.exports = __webpack_public_path__ + "img/search.170852e7.svg";